module.exports = __webpack_public_path__ + "static/media/meter2.3cea0a64.svg";